module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter "), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("two")])])]), _vm._v(" "), _c('p', {
    staticClass: "_ct",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("The Norse "), _c('br'), _vm._v("Pagan World")])]), _vm._v(" "), _c('p', {
    staticClass: "chpt-epigraphs_chpt-epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("They alone are aware who have wandered wide,")])]), _vm._v(" "), _c('p', {
    staticClass: "chpt-epigraphs_chpt-epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And far abroad have fared,")])]), _vm._v(" "), _c('p', {
    staticClass: "chpt-epigraphs_chpt-epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How great a mind is guided by they")])]), _vm._v(" "), _c('p', {
    staticClass: "chpt-epigraphs_chpt-epigraph"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That wealth of wisdom have")])]), _vm._v(" "), _c('p', {
    staticClass: "chpt-epigraphs_chpt-epigraphs-author"
  }, [_vm._v("Havamal 18")]), _vm._v(" "), _c('p', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("T")]), _vm._v("he world is alive, and everything in it moves to an eternal song. Reality for Norse Pagans is far greater than what can be seen and touched. From crude matter and the smallest living things to the mightiest of the Powers, all existence is shaped by greater rhythms. The first step in understanding Norse Paganism is learning these cycles and how they influence your life, and how they bind together. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The core of the world according to Norse Paganism is shaped by four great truths: the World Tree, the cyclical processes that shape reality, the spirits in the world around us, and the all-encompassing web of fate. These truths are at the heart of the universe, shaping all that is. They are as central to reality as the laws of science. Whether you see them as literal fact or powerful metaphors for explaining existence, the three truths carry deep wisdom. Heeding their lessons offers powerful insights for leading worthy, meaningful lives.")]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page18",
      "title": "18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The World Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("The center of the Norse Pagan universe is the World Tree, which is also known as the Yggdrasil (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("IGG-druh-sil")]), _vm._v("). It is the backbone of Norse Paganism’s cosmic ecosystem. Its branches reach in every direction, cradling all the worlds of Norse Paganism. The World Tree’s roots plunge into unfathomable depths and are watered by the three great wells. Everything is connected to and through the Yggdrasil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the Yggdrasil are nine worlds. They are different realms, like parallel universes, governed by their own laws and norms. The highest reaches of the Yggdrasil hold the realms of Asgard and Vanaheim, the homes of the Aesir and Vanir. The gods travel from Asgard to the other realms using the Bifrost, a rainbow bridge guarded by the god Heimdall. Nearby is Alfheim, the home of the Alfar, a powerful group of spirits who have great beauty and mystical prowess. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Halfway down the Tree is Midgard, the Middle Realm. Midgard is all of physical reality as we know it. Earth, the sun, the stars, and the rest of the universe are in Midgard. Encircling the outer limits of Midgard is Jormungandr (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("YOR-mun-gan-dir")]), _vm._v("), a serpent so massive it circles all of reality and holds its tail in its jaws. Nearest to Midgard are Jötunheim, the realm of the third group of gods known as the Jötnar, and Nidavellir (also called Svartalfheim) on the other side, the home of the dwarves. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the great depths watering Yggdrasil are the three great wells of Urd, Mimir, and Hvergelmir (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("VER-gel-meer")]), _vm._v("). On either side of the base are the realms of fire and ice named Muspelheim and Niflheim. When these primal realms collided, in a time separated from ours by an unfathomable abyss, the explosion unleashed by their meeting created the building blocks of Midgard and the ancestors of the gods. The last realm at the World Tree’s base is Helheim, the land of the dead. The dead dwell here in their eternal rest, watching over the living in the comforts of the goddess Hel’s Hall. Gnawing at Yggdrasil’s roots is the dragon Niddhogr (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("NEED-hog")]), _vm._v("), a great dragon whose hunger for the World Tree will never be satisfied and who can never stop chewing at the backbone of reality."), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-041-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-041"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The World Tree’s place as the supporter and sustainer of all worlds makes it essential in Norse Paganism. Everything depends on it. All need the World "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page19",
      "title": "19"
    }
  }, [_vm._v("Tree to exist just as all life on Earth needs healthy, sustainable, and thriving ecosystems to survive. If you could cut any of the Nine Worlds off Yggdrasil, it would probably suffer the same fate as a healthy branch torn from a tree. Even so, the World Tree does not stand above all things like a transcendent deity. It is connected to all and is fed by the waters of the three great wells at its roots. The soil beneath it supports it, giving it life and foundation. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Life is very similar to the World Tree. As has been proven by modern biology, all living beings are made up of countless tiny cells, all too small for the eye to see. Each cell has its own needs that must be met so it can live, thrive and reproduce. These cells do not operate solely on their own, nor in their own narrow interests. When cells come together, they form tissues, organs, and the stuff that makes up all life, from the simplest molds and lichen to complex beings like plants, animals, and humans. Connection and cooperation at the smallest level is the backbone of life as we know it."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-040-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-040"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Following the same pattern is the way in which the broader forces that define our existence work. Living cells are made up of atoms and molecules which are held together by electromagnetic forces. These tiny particles are the building blocks of nonliving matter and the proteins, DNA, and other chemicals that make living beings. Everything is held together by forces we cannot see or touch, yet their influence is as intimate as your heartbeat and as far-reaching as the horizon. This unseen yet indispensable web of connections is the essence of what the World Tree is, means, and how it upholds reality on every level."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-039-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-039"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Cycles of Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("In the Eddas, the ancient sagas of the Norse, it is said that in the beginning there was no Earth. In its place was the Ginnungagap, a great empty void flanked by the fires of Muspelheim and the ice of Niflheim. None know how long this primordial age of opposing forces, separated by the Yawning Gap, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page20",
      "title": "20"
    }
  }, [_vm._v("endured. On one fateful day in the primeval past, for reasons unknown, this tense equilibrium was shattered by a mighty clash of cosmic power. Muspelheim’s flames roared into the gap just as Nifelheim’s ice surged forward with furious intensity. These twin primal forces collided in the empty abyss, unleashing a cataclysmic explosion. In that moment everything changed."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-038-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-038"
    }
  }, [_vm._v("16")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first to emerge from the cooling steam released by the clash of mighty forces were the mighty giant Ymir (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("EE-meer")]), _vm._v(") and the great cow Audumla (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OW-doom-lah")]), _vm._v("). Ymir gave birth to the first of the Jötnar, spawning them from their thighs, arms, legs and sides. Audumla and the giants lived by licking moss off the rocks, while Ymir alone dined on Audumla’s everlasting meat and milk. After an unfathomable eternity, the smallest of things would unwittingly cause reality’s next great upheaval. One day when Audumla was eating, her licking on a patch of frozen lichen freed a bright, shining being from the tundra. This being’s name was Buri, the first of the Aesir. Buri had children with a frost giant, including a son named Bor. Bor, in turn, sired three sons—Odin, Vili, and Ve—with a frost giant. The brothers would end the age of the Great Giant and bring forth the world as we know it."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-037"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Odin, Vili, and Ve lived under the same poverty as their forebears and the other Jötnar. Throughout these long ages, Ymir had kept Audumla’s bounty for themselves, leaving everyone else to scrape a meager living out of the frosty ground. No matter how hard Buri, Bor, their spouse, or the Jötnar worked, nothing changed. None know how long the brothers endured such toil before deciding they’d had enough. One day they rose up, struck against Ymir, and slew them."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-036"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This time, all the gods were given a say in making the new reality, and they used Ymir’s bones, flesh, and blood as material for crafting existence. As it says in the Voluspo:")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spa"
  }, [_vm._v("Then sought the gods their assembly seats,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("The holy ones, and council held;")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Names gave they to noon and twilight,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page21",
      "title": "21"
    }
  }, [_vm._v("Morning they named, and the waning moon,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spb"
  }, [_vm._v("Night and evening, the years to number."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-035"
    }
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Together they made Midgard, deciding all matters through councils and deliberation. After setting the shape of reality, Odin, Lodur, and Hoenir went into Midgard."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-034"
    }
  }, [_vm._v("20")])])]), _vm._v(" As it says in the Voluspo:")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spa"
  }, [_vm._v("Then from the throng did three come forth,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("From the home of the gods, the mighty and gracious;")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Two without fate on the land they found,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Ask and Embla, empty of might.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Soul they had not, sense they had not,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Heat nor motion, nor goodly hue;")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Soul gave Odin, sense gave Hoenir,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spb"
  }, [_vm._v("Heat gave Lodur and goodly hue."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-033"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first humans then opened their eyes, wandering out into Midgard. With no commands, limits, or decrees handed down by their makers, they took their first steps freely, aided by the gifts the gods gave them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These great acts created the world as we know it, crafting the rules that govern this universe and setting it in motion. Yet even the gods, though they demonstrated great power and wisdom in these transformative deeds of destruction and re-creation, are not immune to even greater laws that govern all things on the World Tree. Just as Midgard was created through revolution against Ymir’s power, so too will a new age ultimately come in the distant future. Its onset will be immensely terrible, and many of the gods work tirelessly to delay its arrival. This time is known as Ragnarok, the Doom of the Powers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ragnarok was foretold by the Nameless Seeress, a dead mystic who is uniquely gifted in the arts of prophecy. The Seeress was forced to reveal this terrible future by Odin, who pulled her up from beyond the grave using terrible magics. In the Song of the Seeress, also known as the Voluspo, she revealed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page22",
      "title": "22"
    }
  }, [_vm._v("horrifying truths to the One-Eyed God: in a time to come, all the works of the gods will be undone. Yet despite these visions of fear and loss, a spark of hope burns brightly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It will begin in Midgard. As it says in the Voluspo:")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spa"
  }, [_vm._v("Brother shall kill brother and sisters’ sons will slay")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Hard it is on Midgard with all in reckless abandon")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Axe-time, sword-time shields are sundered")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph"
  }, [_vm._v("Wind-time, wolf-time ere the world falls")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphs_epigraph-spb"
  }, [_vm._v("No one will each other spare"), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-032"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Three roosters will crow, alerting all the final battle is coming. The god Heimdall will sound his great horn for the first and last time, summoning the gods and their allies to battle. They hold council and prepare for the war to end all worlds. The Einherjar, mighty warriors plucked from battlefields across Midgard by the Valkyries throught the centuries to serve in Odin’s great host, muster in Valhalla for the last time."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-031"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Up and down the World Tree, destruction reigns. Slaughter unceasing in Midgard is made worse with the coming of the Fimbulwinter, a time of bitter cold so fierce it unleashes a new ice age. Fenrir, the Great Wolf, shatters the bonds imposed by the gods and runs free, seeking bloody vengeance. Jormungandr, the Midgard serpent, will rise from beneath the waves, flooding the land as it surges forward to slay the gods. In the depths of Muspelheim, Surtr gathers an army of fire giants so vast that Asgard’s Rainbow Bridge will shatter beneath their weight. As disaster grows, the multitudes of newly dead flee for Helheim, hoping for refuge with a great inferno licking at their heels."), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-030"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The armies of Muspelheim march on Asgard. They break the great wall surrounding the realm of the Aesir, charging onto the great fields behind it. There they clash with the host of the gods and the warriors of Valhalla."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-029"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page23",
      "title": "23"
    }
  }, [_vm._v("Surtr duels Freyr, slaying the King of Plenty with a blade forged from white-hot flames. Thor wrestles the Midgard Serpent in a mighty clash for the ages. The two champions rend the ground beneath them in their struggle. Thor just barely breaks his foe, yet will only take nine steps before Jormungandr’s last poisonous breath brings the Thunderer down. Odin charges fiercely into the field but is devoured by Fenrir in a single bite. The great hound Garm, who sat at the roots of Yggdrasil for an endless age, slays Tyr, the god of Justice. Amidst the chaos, Loki arrives with a ship crewed by the dead and unleashes them into the bloodbath, causing further confusion."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-028"
    }
  }, [_vm._v("26")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the swirling carnage, Surtr charges the base of Yggdrasil. He strikes the trunk with his fiery sword, setting all alight. Everything on the World Tree will burn as flames consume all worlds, victor and vanquished alike, and nothing will escape the blaze. All the works of gods and humanity will end. Yet even as this is a cataclysmic ending, Ragnarok is not the end of everything."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-027"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Odin’s son Vidar tears the Great Wolf in two, avenging his father. Thor’s children pull his hammer from the wreckage, standing beside the gods who survive. Two humans, Lif and Lifrasir, ride out the storm hidden in the leaves of the World Tree and will bring a new birth of humanity. The slain god Baldr rises from Helheim to join the new gods in a new world raised from the ruins of the old. Even in the face of Ragnarok’s destruction, another reality will rise, just as this one was born from the great upheaval unleashed by Ymir’s downfall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The story of the Nine Worlds is driven by a consistent cycle. At the beginning of each age of creation is an existing status quo; order itself is maintained by the deeds of those who benefit the most from it. Due to the actions and decisions of those on top, opposing forces develop and seek a new ordering of existence. They eventually rise up and overthrow the old order, creating a new one using the components of what came before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This cycle mirrors processes found in the natural world. The vast pine forests of Scandinavia and central Europe follow a similar pattern of new life emerging from destruction. In these regions, pine trees spread their seeds by growing and dropping pine cones. They can only scatter their seeds when wildfires ignite the sap holding the cones together, flinging seeds in every direction. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page24",
      "title": "24"
    }
  }, [_vm._v("The soil they land in is invigorated by the ashes of the flames, which provide critical nutrients that are essential for new life. This dynamic is not unique to Scandinavia and is seen in many ecosystems worldwide where destruction begets new creation."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-026"
    }
  }, [_vm._v("28")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The march of the seasons moves to the same rhythm. In spring and summer, living beings flourish as plants grow, herbivores eat the plants, carnivores hunt the herbivores and life multiplies. The gifts given by water, wind, and sun nurture everything, nourishing what is and could be. As the days grow shorter and conditions become less hospitable, everything prepares for leaner times. When winter comes, life retreats but does not end. Plants go dormant, and some animals hibernate while others conserve their energy to survive until spring returns."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-025"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Philosophically speaking, this process is very similar to what is known as dialectical logic. In dialectics, all ideas, social systems, and communities are shaped by a continuous process as they grow and change. The components of this process are thesis, antithesis, and synthesis. The thesis is existing status quo, whether that is a widely accepted idea or a community’s current state. The antithesis is a challenge to the thesis, often arising because of flaws or shortcomings in the thesis. Their struggle leads to the synthesis, a new situation made up of elements of thesis and antithesis combined with new ideas and solutions that arose from the earlier struggle."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-024-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-024"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The creation of humanity by the gods follows this same dynamic. The gods did not simply will the first humans into existence any more than they commanded"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page25",
      "title": "25"
    }
  }, [_vm._v(" Midgard to rise from nothingness. They took up two pieces of dead wood, reshaped them, and gave these new creations the gifts of breath, mind, and heat. Much like the creation of Midgard from Ymir’s body or the seeding of new trees in the ashen ground, the gods made humanity by taking existing material they changed and shaped into new forms.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The decisions made in the great cycle are just as critical as the cycle itself. The contrast between the rule of Ymir and the time of Midgardr is critical. Under Ymir, only the great giant feasted on the only source of wealth in all existence. The hoarding and poverty of their lives moved Odin, Vili, and Ve to rebellion. In cooperation with the rest of the gods, they then used Ymir’s body to fashion a new world where all would have space to thrive. Even the surviving Jötnar children of Ymir have a home in Jötunheim and are not ruthlessly hunted into extinction. Humanity and all other beings in the Nine Worlds have the freedom to live as all choose in a world with space for everyone. They replaced an order of domination and inequity with one of freedom and shared prosperity. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was nothing compelling the rebels against Ymir to share as they did. In fact, Ymir’s own rise shows that the gods could have ruled this world just as absolutely as the great giant did. Instead, they built Midgard and Asgard, giving space for all to find their own paths. Their main actions, as shown in the lore, are driven by keeping this order intact instead of imposing their power on those who live in it. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In Radical Norse Paganism, reality moves in cycles. When anything dies, breaks down, or falls apart, its elements and components go back into the world to facilitate new life and new creations. Even if a person or animal dies without siring offspring, they contribute to new life—directly in the form of their decomposing body, and indirectly through the wisdom they shared while living, the fruits of their labor, and the effect their deeds had on the world around them. These broad strokes are consistent even as the details vary. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The only constants in these cycles are life, death, and change. Life endures, adapts, and persists, while always seeking new ways to thrive. Though certain, death does not dictate the moments between beginnings and endings. Change is also certain—sometimes it is the product of time’s ceaseless march and other times it is caused by deliberate action. All things age and eventually pass on, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page26",
      "title": "26"
    }
  }, [_vm._v("but they are only replaced by newer forms through deeds, not by waiting for life to happen on its own. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you accept a reality that’s driven by cycles of great upheaval and transformation, then you need to consider some very tough questions. As existence on all levels and its organization was shaped through action, it is reasonable to conclude the same must be true for your life, the society you live in, and the world around you. The ultimate challenge is to ask yourself what is worth keeping, what must be destroyed, what can be repurposed for something better, and how to do it in the most equitable way possible.")]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spirits All Around Us")])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("In Radical Norse Paganism, everything is alive. From the breeze at our backs to the ground beneath our feet, we live in a world filled with spirits. Oceans roar, forests stretch, and electricity hums all around us. Nothing is ever at rest, whether it is a chunk of concrete underfoot or the mightiest of mountains. In Radical Norse Paganism you live in a world that is constantly in motion. There are entities, beings and intelligences all around you, with their own goals, desires, and drives. This idea is what is commonly known as animism."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-023-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-023"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Animism is the belief that everything, no matter how big or small, has some sort of spirit within it. In Norse Paganism many things, no matter what they are or how unremarkable or insignificant they may seem, have a sacred essence known as a spirit called a vættr, collectively known as the vættir (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vite")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vie-tear")]), _vm._v(".) This is just as true of living beings, such as plant and animal life, as it is of inanimate objects and places. In the lore were often specific things, such as rivers or homes, with their own spirits, though it is difficult to know today what does and does not have its own spirit. Regardless, all things should be treated as if they have a spirit which deserves dignity, respect, and honor. Each has its own critical role to play in the grand design of existence."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-022-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-022"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page27",
      "title": "27"
    }
  }, [_vm._v("The idea that everything has a spirit that deserves our consideration has enormous implications for how life should be lived on a day-to-day basis. If you accept that any number of things around you have a sacred essence worthy of respect, this changes how you live. Objects become more than things and living beings must be given greater respect than what is often shown by modern society. The effect of your actions, decisions, and their consequences take on far greater significance when you act as if uncountable things in the world must be treated with dignity and honor. Everything becomes more than just the chemical reactions and matter that make them possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One good way for explaining how this works is to consider what this perspective means when you think of trees. For most people living today, a tree, while unquestionably alive, is mostly seen in terms of what it provides. Whether they are fruit-bearing, a source of shade, good for climbing, or measured by the potential volume of lumber that can be harvested, trees are viewed based on how people can use them. That a tree is a living being with its own needs is usually secondary for many people to what it can do for them. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For animists, this materialistic approach is the exact opposite of how the living world should be considered and experienced. A tree is a living being that must be respected, revered, and honored, simply for being alive. By existing, it contributes to everything around it in many ways. If it becomes necessary for us to harvest from the tree, it isn’t a simple matter of dispassionately collecting the desired materials; the tree should be honored, thanked, and respected for the gifts it gives every step of the way, especially if those gifts come at the cost of the tree’s existence. You should also only harvest from the tree when it is necessary and not to satisfy a passing urge or out of immediate convenience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All known evidence from pre-Christian times suggests that on a day-to-day level, the bulk of the spiritual focus for Norse peoples was on their relationships with such nature spirits. Of course the gods were still important, but people tended to interact most often with the spirits, the forces they were associated with, and the places they were tied to. Earning the favor of the gods was as important as keeping the spirits in their communities and homes happy for living day-to-day."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-021-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-021"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page28",
      "title": "28"
    }
  }, [_vm._v("The Spirits of Norse Paganism")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the ancient world, many things and places were believed to have their own spirit. The most common spirits were associated with specific places like groves of trees, open fields, and bodies of water. As mentioned earlier, the spirits of natural places are commonly called vættir, and one group in particular is known as husvættir (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HUS-vie-tear")]), _vm._v("), who are tied to specific homes and other dwellings. The island nation of Iceland, according to folklore, is protected by four especially powerful spirits—a vulture, a dragon, a giant, and a bull—that are included in the official Icelandic coat of arms."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-020"
    }
  }, [_vm._v("34")])])]), _vm._v(" It is certainly possible in the present day for individual vættr to be tied to specific streets, neighborhoods, and urban communities. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In addition to the vættr of Norse lore are the well-known alfar, also known as elves. Unfortunately, there is little consistent information on them in the lore; it is known the elves are ruled by Freyr, one of the Vanic gods, have their own realm called Alfheim, are strongly associated with magic, and are described as beautiful and unpredictable. You may have already seen something like them in popular culture. The Norse Alfar directly inspired the elves of J.R.R. Tolkien’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord of the Rings")]), _vm._v(" and many other works of fantasy that followed in Tolkien’s footsteps."), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-019"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another famous group of spirits are the dwarves, who are also known as the Svartalfar or Dark Alfar. They are better understood than the alfar and are said to live in the realm of Nidavellir, also known as Svartalfheim."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-018"
    }
  }, [_vm._v("36")])])]), _vm._v(" They are masters of craftwork, industry, and construction. They made many of the greatest treasures of the Aesir and Vanir, including Thor’s hammer. Whenever the gods need something especially potent, beautiful, or specialized, they "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page29",
      "title": "29"
    }
  }, [_vm._v("nearly always ask the dwarves to make what they need. Given these associations, you could say that they are very close to all forms of present-day crafting, technology, and production. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another famous type of spirits are trolls. Unlike the other spirits, who can be friendly, hostile, or indifferent depending on the spirit, trolls are usually a source of mischief and challenges. Their actions range from annoying pranks to far more dangerous deeds. There is no concrete proof the Norse folklore on trolls is the source of the modern term for certain people on the internet, even though the actions of these digital trolls are rather like their counterparts in folklore. In contrast to trolls are the guardian spirits known as disir. Usually depicted as women, disir watch over specific people and families."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-017"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The last group of spirits are the dead. In Norse Paganism, death is only an end for physical life. A part of your self—and every person’s self—passes on after death to one of many different fates. There is no single destination awaiting those who have passed through this veil, although most people go to Helheim to live in a great community of the dead enjoying a well-deserved rest from the labors of life. The other most well-known places are Freyja’s Hall of Folkvangr and Odin’s Hall of Valhalla, which play host to those who died heroically on the battlefield. Anyone who dies at sea live in the Hall of Aegir and Ran, deep beneath the waves. Some dwell at their grave sites and there are many stories of people who wrestle with the dead to claim their treasures or secrets."), _c('span', {
    staticClass: "fnref CharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-016"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With the sole exception of those who commit the most unspeakable crimes (whose ultimate end is to be devoured by the great dragon Niddhogr), there are no eternal punishments—or rewards—doled out to the dead. This idea goes hand-in-hand with the veneration of the dead for their deeds while alive and the effect they had on the world. In Norse Paganism, death is only a change of how you exist. Either through the effect of your deeds while alive or in a more spiritual sense, it is not the end of your presence in the world."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-015"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page30",
      "title": "30"
    }
  }, [_vm._v("Working with the Spirits")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are many ways to connect with the spirits in the world around you and build enduring relationships with them. The most common way is leaving regular offerings of food, drink, or small gifts of valued, biodegradable materials like hops, grain, or flowers. The practice of offerings dates back to pre-Christian times, where families left out offerings of milk, honey, or grain for the spirits of their homes and the lands they lived on. Showing appreciation for the world around you shows respect for the spirits living there, and it also makes them more aware of you. You can build ties through exploring these places and meditating in them using the methods described in chapter four. Spending time in places that may be homes for vættir will help you gain a greater understanding of those spaces, what they are connected to, and how they influence your life."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-014"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An even deeper, more powerful way of connecting with the spirits and their environments is by caring for the spaces where they make their homes. You could do this by regularly watering a particular tree, cleaning up trash, and other acts of care. Such deeds show respect and reverence for the place and what lives there. If leaving gifts for the vættir shows respect for the spirits, then acts of service demonstrate an even deeper level of reverence. This work also helps by restoring the space, making it whole, and ensuring it is hospitable for all who need it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On a broader level, animism challenges the manner in which we should live in the modern world. Society today operates as if everything on Earth should be treated as disposable commodities. Trees are assessed in tons of lumber, hills and mountains by the size of their mineral deposits, oceans for oil drilling and fish stocks, and even the sky is carved into lanes for air traffic. If you see a cow as so many cuts of beef instead of a living thing whose death will sustain many, or an open field as space to be developed for maximum profit instead of as a home for many living things, it becomes dangerously easy to abuse anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In this world of disposable, replaceable things is little room for dignity or respect. When the most important kind of value measures only how many expensive things you own and the size of your paycheck, everything suffers. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page31",
      "title": "31"
    }
  }, [_vm._v("Such crude reduction of the beautiful, interconnected reality everything needs to survive into mere commodities denies the essence inside of all things. There is no question that this alienation stands in clear opposition to living an animistically guided life. However, when your understanding of the natural world and society is based on a complex web of dynamic relationships, nothing can be treated as a lone object operating in isolation. All things depend on and influence each other. When you cut down a tree, every living thing in it faces destruction. Tearing up a cherished city park to make way for a high-rise block of luxury condos destroys the heart of a community along with the greenery and playing fields. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Modern society’s practice of reducing places, beings, communities, and people to numbers on balance sheets has unleashed unprecedented environmental destruction on the world and has justified awful acts of total dehumanization. At its worst, this materialistic mentality has enabled the horrors of the slave trade and wholesale genocide, including the destruction of the First Nations of the Americas and the Nazi death camps. According to the latest scientific research on the health of the environment, life on Earth will soon be an impossibility if modern society does not change.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Practitioners of Radical Norse Paganism believe that everything is alive in one way or another, and its animistic perspective urges us to live with respect for all things around us. The consequences of your actions are felt in many ways, some of which may not be obvious. You should always move in life fully aware of the consequences of your decisions and their impact on the world. Living in this way brings you closer to the world around you and helps you lead a more complete life.")]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("The final truth guiding Radical Norse Paganism is Fate, the influencer of all things. Its tug, touch and tensions shape life. No thing, not even the gods, are free from Fate. Yet the Norse concept of Fate is not that of an immutable, unchanging thing dictating how all events will always unfold. Instead, it is an active, dynamic force shaped by the deeds of all things in every world. Though you may not be able to dictate what card Fate deals you, you can decide how to play your hand and, through sustained work, change the game for the better. There are two forces shaping how Fate’s influence shapes everything in the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page32",
      "title": "32"
    }
  }, [_vm._v("Nine Worlds—"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" and hamingja (pronounced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OAR-log")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ha-ming-ya")]), _vm._v(")—who represent the sum of all actions and every individual’s capacity to change Fate.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The skeletal framework of Fate is "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(". "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" is made up of all the things in life that have already been determined by past deeds beyond our control, existing elements of society that come about through the accumulation of many actions over time, or the consequences of all actions. This includes the time and place of your birth, your parents, the consequences of others’ actions, and the other elements of your life that cannot be changed. The beings with the most influence over "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" are the Norns, three goddesses who dictate when you and all other living things are born and when all will ultimately die. They also feed the World Tree with waters drawn from the wells that hold the pure potential of Fate. Beneath the Norns "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" is shaped by the accumulated weight of the deeds of all who have ever lived. Every life can change the shape of the "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" surrounding their lives in ways both obvious and hidden. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To break it down to a personal level, the fact that you were born in the present time, place, and circumstances is because of the decisions made by others. For example, that you were born in a particular place was the result of how your parents met and what they chose to do after you were conceived. The decisions made by your parents created what are, for you, inalterable facts. In turn, their choices were likely shaped by other circumstances beyond their control, such as what kind of work they found to support themselves, the circumstances of the place where they live, the conditions they work in, how they were born into world, and how it affected them. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Your past and present actions, choices, and effect on the world are then shaped both by circumstances you can’t control (such as the conditions of the community where you were born, what sort of opportunities for supporting yourself or others were available, traits that are an inherent part of who you are,) as well as the effect any existing prejudices or biases in society had on those circumstances. Some of these circumstances result from actions of specific individuals, the accumulated weight of the actions of many unfolding across history and collective action by groups of people working to change their circumstances. This is all before even going into the way any of the Powers—from the humblest spirit to the mightiest god—affect the state of the world "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page33",
      "title": "33"
    }
  }, [_vm._v("and everything in it. All of this is "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(", and all of these decisions are shaped by "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v("."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-013"
    }
  }, [_vm._v("41")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This all probably sounds very intimidating, and you may be wondering how it’s possible to change Fate in any meaningful way when there is so much inertia behind all that is. The answer is your hamingja, also known as luck. For most people living today, luck is little more than random chance or unexpected encounters. In Radical Norse Paganism, nothing could be further from the truth. Your hamingja is inherently part of you, made of all your skills, means, immediate conditions, and anything else in your life capable of changing yourself and your circumstances. Hamingja comes from what is passed on to you from the circumstances of your birth by those who came before. Anything in the "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" affecting your life affects your capacity to cause change. Actions you take grow or shrink your ability to cause change. By making decisions and doing deeds that use what is part of your hamingja, you can change "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v("."), _c('span', {
    staticClass: "fnref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-012"
    }
  }, [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The place where these forces meet is where Fate is shaped. When people use their hamingja to change their lives, their circumstances, or conditions facing others, they change existing "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(". In changing the "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(", they also create a new and different "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" that will affect lives in different ways. Some things that are "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(", particularly when the circumstance in question is a product of social institutions, are more resistant to being changed by your hamingja than others. Sometimes it is only possible for you to change a small portion of "), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(", while in other cases it may be possible to have a much greater influence. This also means your actions and the actions of others are intimately connected, with all playing a role in shaping the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There might be times when you are facing "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" that it looks bigger than what you on your own can change with your hamingja. Sometimes the solution is to think of different ways of applying your capabilities. There might be an indirect way to solve a problem when a direct solution doesn’t work. You might also be facing "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" that will take time and sustained effort to alter. In other cases, especially if you are dealing with "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" impacting communities or society, you may need to work with others to achieve your goal. When people work collectively to change "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(", the manner in which they interact with Fate "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page34",
      "title": "34"
    }
  }, [_vm._v("changes. People working together pool their hamingja into a greater force than any of their individual means, creating a far greater capacity for causing change.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is important to remember every person’s hamingja is different, just as every individual is different. This means some things that are "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" impact people in different ways. The possession or lack of specific components of hamingja does not make any one person inherently greater or lesser than anyone else. It is simply a matter of means, conditions, and how "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" affects them. Sometimes there are also "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" that are too great to be changed easily (e.g., powerful institutions), or even at all, as is the case in universal laws. This does not mean you should simply accept what is. If there is "), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("Ørlog")]), _vm._v(" that is harmful to yourself, others, or whole communities, you should still do everything in your power to change it. In Radical Norse Paganism, it is always better for you to try your best to improve your circumstances than to meekly accept them without complaint. As the example of the gods and Ragnarok shows, even if something is inevitable or more powerful than you can handle, you should still do everything you can to change your circumstances, community, and society for the better.")]), _vm._v(" "), _c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pulse of Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("At the heart of Radical Norse Paganism are four central truths: the World Tree sustaining all of reality, the cycles that define everything, the living world of the spirits around us, and Fate’s dynamic and inescapable influence. When put together, they show the world is deeply interconnected and our actions can change it. By understanding these greater patterns and dynamics, you can better understand the Powers, develop an understanding of spirituality, and find the best way to lead a worthy, fulfilling life. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As massive (and at times overwhelming) as this all may look, there is a kind of comfort you can take from it. When you accept the world as one where even the greatest gods live under the same laws as the smallest living things, it opens up incredible possibilities. The struggles and challenges you face are shared by many others, including the mightiest Powers. This means you can learn from the examples, successes, and mistakes of others and find ways to use this wisdom to improve your life. It also means you can genuinely make such changes in your life, your community, and the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page35",
      "title": "35"
    }
  }, [_vm._v("The following exercise will help you better understand how you and everything around you is connected. You may find this exercise gives you even greater insights when you do it in different places, times, or circumstances. With time and practice, it will also improve your day-to-day awareness of the world around you.")])]), _vm._v(" "), _c('p', {
    staticClass: "exheads_exhead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("exercise")])]), _vm._v(" "), _c('p', {
    staticClass: "exheads_exhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Spatial Awareness")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-txni"
  }, [_vm._v("Begin by finding a place outdoors where you can sit in place without fear of being disturbed or made unsafe. Follow the steps of the breathing exercise outlined in chapter one. Continue the breathing exercise until your heartbeat is calm and you feel at ease. Keep your eyes closed throughout the exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-tx"
  }, [_vm._v("Once your body is in this resting state, focus on your hearing. Let your attention drift and take in everything around you. Let the sounds of the immediate environment fill your mind. Listen deeply, savoring every sound you can.")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-tx"
  }, [_vm._v("You can also do the same with your sight. If you choose this approach, keep your eyes open and take in all the sights around you. Do not focus on any specific detail, item, or thing present; instead, let your eyes take in everything around you. Let your vision drift without focusing on any specific thing. Regardless of the method you use, once you have taken in your surroundings, you are ready for the next step in this exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-tx"
  }, [_vm._v("You should now focus on seeking out four specific things with your senses. If you are using your ears, search for the quietest sound you can hear, the loudest sound you can hear, the farthest sound from you that you can hear, and the closest sound to you that you can hear. If you are using your eyes, look for the smallest thing you can see without moving your head or eyes. Look again for the largest thing, the closest thing, and the farthest thing.")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-tx"
  }, [_vm._v("Once you have found what you are seeking, listen or watch for whatever is in their vicinity. Everything in the world moves in relationship with everything else, just as we all live in relationships with "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page36",
      "title": "36"
    }
  }, [_vm._v("the spirits around us. Once you have determined the closest things to each of the four things you have observed, you may return your focus to normal.")])]), _vm._v(" "), _c('p', {
    staticClass: "exheads_ex-tx"
  }, [_vm._v("Take time to reflect on what you have observed.")]), _vm._v(" "), _c('p', {
    staticClass: "exheads_contents _idGenParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-041"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-041-backlink"
    }
  }, [_vm._v("13")]), _vm._v(". Ibid")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-040"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-040-backlink"
    }
  }, [_vm._v("14")]), _vm._v(". “KS3 Bitesize Science—Cells to Systems: Revision, Page 5.” BBC. Accessed August 22, 2018. http://www.bbc.co.uk/bitesize/ks3/science/organisms_behaviour_health/cells_systems/revision/5/.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-039"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-039-backlink"
    }
  }, [_vm._v("15")]), _vm._v(". “How Do Molecules Interact?” OpenLearn. August 08, 2006. Accessed August 22, 2018. http://www.open.edu/openlearn/science-maths-technology/science/chemistry/how-do-molecules-interact.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-038"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-038-backlink"
    }
  }, [_vm._v("16")]), _vm._v(". Voluspo 3, Poetic Edda; Gylfaginning 4, Prose Edda, Jesse L. Byock Translation")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-037"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-037-backlink"
    }
  }, [_vm._v("17")]), _vm._v(". Voluspo 3, Vafthruthnismol 21, Poetic Edda; Gylfaginning 5, Prose Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-036"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-036-backlink"
    }
  }, [_vm._v("18")]), _vm._v(". Voluspo 4-6, Poetic Edda; Gylfaginning 8, Prose Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-035"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-035-backlink"
    }
  }, [_vm._v("19")]), _vm._v(". Voluspo 6, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-034"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-034-backlink"
    }
  }, [_vm._v("20")]), _vm._v(". Some say Lodur and Loki are the same being, not much is known about Hoenir due to a lack of surviving material")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-033"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-033-backlink"
    }
  }, [_vm._v("21")]), _vm._v(". Voluspo 17-18, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-032"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-032-backlink"
    }
  }, [_vm._v("22")]), _vm._v(". Voluspo 45, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-031"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-031-backlink"
    }
  }, [_vm._v("23")]), _vm._v(". Voluspo 42-48, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-030"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-030-backlink"
    }
  }, [_vm._v("24")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Voluspo 46-52, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-029"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-029-backlink"
    }
  }, [_vm._v("25")]), _vm._v(". Voluspo 53-56, Poetic Edda; HR Ellis Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Road to Hel: A Study of the Conception of the Dead in Old Norse Literature")]), _vm._v(", Greenwood Press (Westport, Connecticut: 1968), 66-82")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-028"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-028-backlink"
    }
  }, [_vm._v("26")]), _vm._v(". Voluspo 53-56, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-027"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-027-backlink"
    }
  }, [_vm._v("27")]), _vm._v(". Voluspo 57, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-026"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-026-backlink"
    }
  }, [_vm._v("28")]), _vm._v(". “Scandinavian Mountains over 2000 metres - James Baxter.” Scandinavian Mountains - Flora and Fauna. Accessed November 12, 2017. http://www.scandinavianmountains.com/flora-fauna/trees-shrubs/index.htm.; “How Do Pine Trees Reproduce?” Sciencing. Accessed November 12, 2017. https://sciencing.com/do-pine-trees-reproduce-5173107.html.; “How Trees Survive and Thrive After A Fire.” National Forest Foundation. Accessed November 12, 2017. https://www.nationalforests.org/our-forests/your-national-forests-magazine/how-trees-survive-and-thrive-after-a-fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-025"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-025-backlink"
    }
  }, [_vm._v("29")]), _vm._v(". “The Seasonal Cycle of Atmospheric Heating and Temperature.” American Mete-orological Society. Accessed November 30, 2015. http://journals.ametsoc.org/doi/abs/10.1175/JCLI-D-12-00713.1")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-024"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-024-backlink"
    }
  }, [_vm._v("30")]), _vm._v(". Maybee, Julie E. “Hegel’s Dialectics.” Stanford Encyclopedia of Philosophy. June 03, 2016. Accessed November 12, 2017. https://plato.stanford.edu/entries/hegel-dialectics/")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-023"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-023-backlink"
    }
  }, [_vm._v("31")]), _vm._v(". Park, George Kerlin. “Animism.” Encyclopædia Britannica. December 19, 2016. Accessed August 22, 2018. https://www.britannica.com/topic/animism.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-022"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-022-backlink"
    }
  }, [_vm._v("32")]), _vm._v(". Reimund Kvideland and Henning K. Sehmsdorf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scandinavian Folk Belief and Legend")]), _vm._v(", University of Minnesota Press (Minneapolis: 1988), 8-10; Alda Sigmunsdottir, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Book of the Hidden People")]), _vm._v(", Little Books Publishing (Reykjavik: 2015), 11-13; “1179 (Svensk Etymologisk Ordbok).” Project Runeberg. Accessed August 22, 2018. http://runeberg.org/svetym/1267.html.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-021"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-021-backlink"
    }
  }, [_vm._v("33")]), _vm._v(". Kvideland and Sehmsdorf 9")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-020"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-020-backlink"
    }
  }, [_vm._v("34")]), _vm._v(". Davidson, Hilda Roderick Ellis. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Myths and Symbols in Pagan Europe: Early Scandinavian and Celtic Religions")]), _vm._v(". Syracuse: Syracuse Univ. Press, 2006. 102-104; Davidson, Hilda Roderick Ellis. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lost Beliefs of Northern Europe")]), _vm._v(". London: Routledge, 1994, 119-121; Kvideland and Sehmsdorf 8-10; “History | Icelandic Coat of Arms.” Prime Minister´s Office. Accessed November 12, 2017. https://eng.forsaetisraduneyti.is/state-symbols/icelandic-coat-of-arms/history/#Guardian_spirits")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-019"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-019-backlink"
    }
  }, [_vm._v("35")]), _vm._v(". Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Myths and Symbols in Pagan Europe: Early Scandinavian and Celtic Religions")]), _vm._v(", 109,172-173; Sigmundsdottir 11-12")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-018"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-018-backlink"
    }
  }, [_vm._v("36")]), _vm._v(". Crossley-Holland xxxi-xxxii; Ross, Margaret Clunies. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prolonged Echoes: Old Norse Myths in Medieval Northern Society")]), _vm._v(". Odense: Odense University Press, 1994, 73-74")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-017"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-017-backlink"
    }
  }, [_vm._v("37")]), _vm._v(". John Lindow, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trolls: An Unnatural History")]), _vm._v(", Reaktion Books (London: 2014), 14-25; Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lost Beliefs of Northern Europe")]), _vm._v(", 113")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-016"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-016-backlink"
    }
  }, [_vm._v("38")]), _vm._v(". Ross 251-256; Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Road to Hel ")]), _vm._v("2-6, 83-95, 99-104")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-015"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-015-backlink"
    }
  }, [_vm._v("39")]), _vm._v(". Voluspo 39, Poetic Edda")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-014"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-014-backlink"
    }
  }, [_vm._v("40")]), _vm._v(". Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lost Beliefs of Northern Europe")]), _vm._v(", 103-104,137; Kvideland and Sehmsdorf, 8–10.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-013"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-013-backlink"
    }
  }, [_vm._v("41")]), _vm._v(". Ross, 242–243; Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gods and Myths of Northern Europe")]), _vm._v(" 217–219")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-012"
    }
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/WFI1#footnote-012-backlink"
    }
  }, [_vm._v("42")]), _vm._v(". Davidson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Myths and Symbols in Pagan Europe")]), _vm._v(", 134, 166")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b881408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WFI-1.vue
// module id = 75
// module chunks = 0